<template>
  <pt-life-experience-finance-audit class="pt-life-experience-finance-audit__withData"></pt-life-experience-finance-audit>
</template>

<script>
import PtLifeExperienceFinanceAudit from './index'
export default {
  name: 'pt-life-experience-finance-audit__withData',
  components: {
    'pt-life-experience-finance-audit': PtLifeExperienceFinanceAudit
  }
}
</script>
